import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  UnauthorisedPageSurface,
  PageWrapper,
} from "../../../../components/layout/container/Container";
import { useVerifyEmail } from "../hooks/useVerifyEmail";
import FeedbackStatus from "../../../../components/feedback/FeedbackStatus";
import "./VerifyEmailPage.css";

const VerifyEmailPage = () => {
  document.title = "Katch | Verify Email";

  const { token } = useParams();
  const navigate = useNavigate();

  const { status } = useVerifyEmail(token, navigate);

  const renderContent = () => {
    if (status.loading) {
      return <p>Securing your Katch account...</p>;
    }

    if (status.success) {
      return (
        <div className="verify-email-content">
          <FeedbackStatus
            title={"Email verified"}
            description={`${status.message}. Redirecting to sign in…`}
            buttonText={"Back to Sign in"}
            onAction={() => navigate("/sign-in")}
          />
        </div>
      );
    }

    const isInfo = status.alreadyVerified;

    return (
      <div className="verify-email-content">
        <FeedbackStatus
          title={isInfo ? "Already verified" : "Verification failed"}
          description={status.message}
          buttonText={"Back to Sign in"}
          onAction={() => navigate("/sign-in")}
        />
      </div>
    );
  };

  return (
    <UnauthorisedPageSurface>
      <PageWrapper size={"sm"}>
        <div className="verify-email-content">{renderContent()}</div>
      </PageWrapper>
    </UnauthorisedPageSurface>
  );
};

export default VerifyEmailPage;
